export default __webpack_public_path__ + "static/media/147.042d9717.png";